/** Figma design tokens — Buttons, Tags, Order Status, Actions, Form fields */
export const colors = {
  primary: "#083B4C",
  primaryHover: "#03151C",
  primaryActive: "#5A7C87",
  primaryLight: "#E3E9EB",
  secondary: "#FF9B53",
  success: "#00D69F",
  successDark: "#00A379",
  successLight: "#E1FAF3",
  successActiveBg: "#E3FAF4",
  info: "#118AB2",
  infoLight: "#E4F2F7",
  error: "#E84A4A",
  errorDark: "#E21D1D",
  errorLight: "#FFE6E6",
  neutral: "#5E5E5E",
  neutralBg: "#E8E8E8",
  disabled: "#D1D1D1",
  textMuted: "#9A9A9A",
  title: "#092C4C",
  fieldBorder: "#A3A3A3",
  fieldText: "#030F1B",
  fieldPlaceholder: "#9A9A9A",
};

/** Figma Order Status row */
export const ORDER_STATUS_VARIANTS = {
  NEW: "neutral",
  PENDING: "warning",
  "TIME OUT": "neutral",
  TIMEOUT: "neutral",
  REJECTED: "error",
  CANCELLED: "error",
  CANCELED: "error",
  DRAFTED: "success",
  ACCEPTED: "success",
  COMPLETED: "success",
  "COMPLETED (PREPARED)": "success",
  DELIVERED: "success",
  DELIVERD: "success",
  "READY FOR DELIVERY": "success",
  "OUT FOR DELIVERY": "info",
  PREPARED: "info",
  FINISHED: "info",
  "RIDER ASSIGNED": "info",
};

/** Figma Tags row */
export const TAG_LABEL_VARIANTS = {
  connected: "success",
  synced: "success",
  available: "success",
  archive: "success",
  linked: "linked",
  unlink: "linked",
  "branch manager": "role",
  "device manager": "role",
  disconnected: "error",
  "not synced": "error",
  "de-synced": "error",
  desynced: "error",
  "un-archive": "error",
  unavailable: "error",
  active: "success",
  inactive: "neutral",
  "under review": "warning",
};
